import { OportunityCard } from "./Card";
import { Acuarela, Separador } from "./Image";

export const AcuarelaSection = (props)=>{
    return(
        <>
        <Acuarela src={props.src}/>
        <OportunityCard 
            sar={props.sar}
            title={props.title}
            message={props.message}
            description={props.description}/>
        <Separador src={props.separator}/>
        </>
    )
}